import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { runRtkQuery } from '../helperFn';

export const emailApi = createApi({
  reducerPath: 'emailApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    sendEmail: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'sendEmail');
      },
    }),
  }),
});

export const { useSendEmailMutation } = emailApi;
